import React from 'react';
import Overview from '../../components/Admin/Overview/Overview';

const Dashboard = () => {
  return <Overview />;
};

export default Dashboard;
